module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "permanent",
    attrs: {
      "label": "发布设置"
    }
  }, [_c('quotas-required-dialog', {
    ref: "quotas-required-dialog",
    on: {
      "close": _vm.close
    }
  }), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.permanent),
      callback: function($$v) {
        _vm.permanent = $$v
      },
      expression: "permanent"
    }
  }, [(!_vm.project.permanent) ? _c('el-radio-button', {
    attrs: {
      "label": "temp"
    }
  }, [_vm._v("\n      临时\n      "), _c('span', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.timeDiff(_vm.project.expired_at) > 0 ? _vm.timeDiff(_vm.project.expired_at, true) + '过期' : '<span class=\'danger\'>已过期</span>')
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "permanent"
    }
  }, [_vm._v("\n      永久\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82ad2cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/permanent.card.vue
// module id = 935
// module chunks = 3